<template>
  <div class="pa-4 text-center">

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <v-card class="container justify-content-between align-items-center">
        <img src="https://beneflex-icons.s3.amazonaws.com/clients/logo1.svg" />
        <h2 color="primary">Cambiar contraseña</h2>

        <v-container>
          <v-row dense>
            <v-col md="12" sm="6">
              <v-text-field label="*Nueva contraseña" :type="passwordFieldType" required
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" outlined v-model="user.password"
                :rules="[...passwordRules]" color=primary :counter="15" :maxlength="15"
                @click:append="togglePasswordVisibility">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="12" sm="6">
              <v-text-field label="*Confirmar contraseña" :type="confirmationFieldType" required
                :append-icon="showConfirmation ? 'mdi-eye' : 'mdi-eye-off'" outlined v-model="user.confirmationPassword"
                :rules="[...confirmPasswordRule]" color=primary :counter="15" :maxlength="15"
                @click:append="toggleConfirmationVisibility">
              </v-text-field>
              <span
                v-if="user.password && user.confirmationPassword && validatePasswordRepeat(user.confirmationPassword, user.password) !== null && validatePassword(user.password) === null && validatePassword(user.confirmationPassword) === null"
                class="error-message password-match-rule-error">Las contraseñas no coinciden</span>
            </v-col>
            <v-spacer></v-spacer>

            <v-btn large block rounded color="primary" class="mb-4" style="color: white; border-radius: 50px;"
              @click="changePassword">
              Cambiar
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  LOGIN_M,
  GET_USER,
  ACTION_UPDATE_PASSWORD
} from "@/views/login/store/types/types.js";
import { mapActions, mapGetters } from 'vuex';
import Swal from "sweetalert2";


export default {
  name: "FormPasswordValidation",
  props: {
    forgottenPass: {
      required: true,
      type: Boolean
    },
  },
  data() {
    return {
      dialog: true,
      passwordFieldType: 'password',
      confirmationFieldType: 'password',
      showPassword: false,
      showConfirmation: false,
      passwordsFullyEntered: false,

      user: {
        password: "",
        confirmationPassword: "",
        forgottenPass: this.forgottenPass
      },
    }

  },



  computed: {
    passwordRules() {
      return [
        v => !!v || "Campo requerido",
        v => v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || 'La contraseña debe contener al menos 1 letra mayúscula, 1 número y 1 carácter especial permitido (@#$_&-+()/*"\':;!?)',
      ];
    },

    confirmPasswordRule() {
      return [
        v => !!v || "Campo requerido",
        v => v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',
        v => /(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(v) || 'La contraseña debe contener al menos 1 letra mayúscula, 1 número y 1 carácter especial permitido (@#$_&-+()/*"\':;!?)',
      ];
    },

    passwordMatchRule() {
      return [
        v => (!!v && v === this.user.password) || "Las contraseñas no coinciden",
        v => (!!v && v === this.user.confirmationPassword) || "Las contraseñas no coinciden"
      ];
    }
  },

  methods: {

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.passwordFieldType = this.showPassword ? 'text' : 'password';
    },

    toggleConfirmationVisibility() {
      this.showConfirmation = !this.showConfirmation;
      this.confirmationFieldType = this.showConfirmation ? 'text' : 'password';
    },

    validatePasswordRepeat(passwordRepeat, password) {

      const passwordError = this.validatePassword(password);
      const passwordRepeatError = this.validatePassword(passwordRepeat);

      if (passwordError || passwordRepeatError) {

        return passwordError || passwordRepeatError;
      } else {

        if (passwordRepeat !== password) {
          return 'Las contraseñas no coinciden';
        } else {
          return null;
        }
      }
    },
    validatePassword(password) {
      if (!password) return 'Campo requerido';
      if (password.length < 8) return 'La contraseña debe tener al menos 8 caracteres';
      if (/(?=.*[A-Z])(?=.*\d)(?=.*[@#$_&\-+()/*"':;!?])[A-Za-z\d@#$_&\-+()/*"':;!?]{8,}/.test(password)) return 'La contraseña debe contener al menos 1 letra mayúscula, 1 número y 1 carácter especial permitido (@#$_&-+()/*"\':;!?)'
            return null;
    },

    ...mapActions({
      putChangePassword: `${LOGIN_M}${ACTION_UPDATE_PASSWORD}`,
    }),

    ...mapGetters({
      obtenerInfoUser: `${LOGIN_M}${GET_USER}`,
    }),


    async changePassword() {
      const errors = this.validateForm();

      if (Object.keys(errors).length > 0) {
        const errorMessages = Object.values(errors).join('<br>');
        return Swal.fire({
          icon: 'error',
          title: 'Errores de validación',
          html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
          confirmButtonColor: '#6E17A5'
        });
      }
      const updatePassword = await this.putChangePassword(this.user);
      if (!updatePassword) {
        return Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Debes diligenciar los campos'
        })
      }

      this.dialog = false;
      window.location.reload();

    },

    validateForm() {
      const PASSWORD_REGEX = /(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&/*(),.?":;{}|<>=+\-^])[A-Za-z\d!@#$%&/*(),.?":;{}|<>=+\-^]{8,}/;

      const errors = {};

      if (!this.user.password || this.user.password.trim().length < 8 || !PASSWORD_REGEX.test(this.user.password)) {
        errors.password = "Nueva contraseña";
      }

      if (!this.user.confirmationPassword || this.user.confirmationPassword.trim().length < 8 || !PASSWORD_REGEX.test(this.user.confirmationPassword)) {
        errors.confirmationPassword = "Confirmar contraseña";
      } else if (this.user.confirmationPassword !== this.user.password) {
        errors.confirmationPassword = "Las contraseñas no coinciden";
      }

      return errors;
    },
  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 40vh;
}

.password-match-rule-error {
  color: red;
  font-size: 12px;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;
  }
}
</style>